export const canOrderBeResigned = (order) => {
	if (
		order.status === 'confirmed' &&
		order.shipping.status &&
		(order.shipping.status === 'to_send' ||
			order.shipping.status === 'lms_sent')
	) {
		return true;
	}

	return false;
};
